// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"styles--formLabel--3x96A","formInput":"styles--formInput--2Lez0"};